import { featuredBrandData } from './mocks'
import useFeaturedBrand from './useFeaturedBrand'


const useFeaturedBrandBanner = (): BrandsModule.FeaturedBrandBannerData => {
  const featuredBrand = useFeaturedBrand()

  return featuredBrandData[featuredBrand]?.bannerData
}

export default useFeaturedBrandBanner
